import i18n from './i18n';

// Export a globally usable translation function
export const t = (key, options) => i18n.t(key, options);

// Optional: expose on window for ad-hoc usage outside React components
try {
    if (typeof window !== 'undefined') {
        window.i18n = i18n;
        window.t = (key, options) => i18n.t(key, options);
    }
} catch (e) {}

export default t;

